<mat-list>
  <mat-list-item *ngFor="let country of countries">
    {{country}}
  </mat-list-item>
</mat-list>
